module["exports"] = [
  "ИП",
  "ООО",
  "ЗАО",
  "ОАО",
  "НКО",
  "ТСЖ",
  "ОП"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/company/prefix.js
// module id = 1632
// module chunks = 0